// Filter
export const ORDER_HISTORY_FILTER_DELIVERY_STATUS = 'deliveryStatus';
export const ORDER_HISTORY_FILTER_INVOICE_STATUS = 'invoiceStatus';
export const ORDER_HISTORY_FILTER_FROM_DATE = 'fromDate';
export const ORDER_HISTORY_FILTER_TO_DATE = 'toDate';
export const ORDER_HISTORY_FILTER_CREATED_ON = 'createdOn';
export const ORDER_HISTORY_FILTER_FULLNAME = 'fullName';
export const ORDER_HISTORY_FILTER_LASTMONTH = 'Last month';
export const ORDER_HISTORY_FILTER_LAST3MONTH = 'Last 3 months';
export const ORDER_HISTORY_FILTER_LAST2YEARS = 'Last 2 years';
export const ORDER_HISTORY_FILTER_EMPTY = '';
export const ORDER_HISTORY_FILTER_RANGE = 'range';

// Table columns
export const ORDER_HISTORY_COLUMN_ORDER_NUMBER = 'orderNumber';
export const ORDER_HISTORY_COLUMN_ACTION = 'action';
export const ORDER_HISTORY_COLUMN_PO_NUMBER = 'poNumber';
export const ORDER_HISTORY_COLUMN_SOLD_TO_NAME = 'soldToName';
export const ORDER_HISTORY_COLUMN_SHIP_TO_NAME = 'shipToName';
export const ORDER_HISTORY_SCHEDULE_LINE_CONFIRMED_DATE = 'confirmedDate';

export const ORDER_HISTORY_SWITCH_DATE_FILTER_TIMEOUT = 500;

export const ORDER_HISTORY_DATE_FILTER_ONE_MONTH = 1;
export const ORDER_HISTORY_DATE_FILTER_THREE_MONTH = 3;
export const ORDER_HISTORY_DATE_FILTER_TWO_YEARS = 24;

export const ORDER_HISTORY_ERROR_CODE_NO_SOLD_TO = 400;
export const ORDER_HISTORY_ERROR_CODE_NO_ORDERS = 401;

export enum OrderStatus {
    Unknown = '00',
    Queued = '05',
    Submitted = '10',
    Canceled = '20',
    Confirmed = '30',
    Processing = '40',
    Completed = '90'
}

export enum DateRangeType {
    Min = 'MIN',
    Max = 'MAX'
}

export const ALL_STATUS = `ALL`;
export const OPEN_STATUS = `OPEN`;
export const ORDER_HISTORY_ORDER_TYPE = 'orderType';

export const ORDER_HISTORY_EXPORT_CONFIGURATION_KEY = 'export-configuration';

// Map keys to apply localization
export const XLSX_TABLE_KEY_MAPPING: { [key: string]: string } = {
    OrderNumber: 'orderHistoryOrderNumberText',
    PoNumber: 'orderHistorySalesOrderPONumber',
    Status: 'orderHistoryOrderStatusText',
    ConfirmedDate: 'orderHistorySalesOrderCreatedOn',
    ConfirmedQty: 'orderHistoryDetailsConfirmedQuantity',
    ConfirmedUnit: 'orderHistoryDetailsConfirmedUnit',
    ScheduleLineConfirmedDate: 'orderHistoryDetailsConfirmedDate',
    SoldToName: 'orderHistorySalesOrderSoldTo',
    ShipToName: 'orderHistorySalesOrderShipTo',
    ProductName: 'orderHistoryDetailsProductName',
    ProductNumber: 'orderHistoryDetailsProductNumber',
    CustomerProductNumber: 'orderHistoryDetailsCustomerProductNumber',
    RequestedDate: 'orderHistoryDetailsRequestedDate',
    RequestedQty: 'orderHistoryDetailsRequestedQuantity',
    NetValue: 'orderHistoryDetailsNetValue',
    RequestedUnit: 'orderHistoryDetailsRequestedUnit',
    SoldToCity: 'orderHistorySalesOrderSoldToCity',
    SoldToId: 'orderHistorySalesOrderSoldToId',
    ShipToId: 'orderHistorySalesOrderShipToId',
    ShipToCity: 'orderHistorySalesOrderShipToCity',
    SalesOrganisationText: 'orderHistorySalesOrganisation',
    DistributionChannelText: 'orderHistoryDistributionChannel',
    DivisionText: 'orderHistoryDivision',
    Incoterms2: 'orderHistoryIncoterms2',
    Currency: 'orderHistorySalesOrderCurrency',
    ShipFlightNumber: 'orderHistoryShipFlightNumber',
    Container: 'orderHistoryContainerNumber',
    CarrierName: 'orderHistoryCarrierName',
    BlNumber: 'orderHistoryBLNumber',
    ContainerType: 'orderHistoryContainerType',
    EstimatedArrivalDate: 'orderHistoryEstimatedArrivalDate',
    ActualArrivalDate: 'orderHistoryActualArrivalDate',
    InvoiceNumber: 'orderHistoryInvoiceNumber',
    GoodsMovementDate: 'orderHistoryGoodsMovementDate',
    EstimatedShippingDate: 'orderHistoryEstimatedShippingDate',
    FreightOrderMainCarriage: 'orderHistoryFreightOrderMainCarriage',
    FreightOrderPreCarriage: 'orderHistoryFreightOrderPreCarriage',
    BookingNumber: 'orderHistoryBookingNumber',
    StateLogistics: 'orderHistoryLineOrderStatusText',
    StateInvoice: 'orderHistoryLineInvoiceStatusText',
    ScheduleLineNumber: 'orderHistoryScheduleLineNumber',
    LineNumber: 'orderHistoryLineNumber'
};

export const XLSX_TABLE_GROUP_KEY_MAPPING = {
    Order: ['OrderNumber', 'PoNumber', 'Status', 'ConfirmedDate', 'StateLogistics'],
    Address: [
        'SoldToName',
        'ShipToName',
        'SoldToCity',
        'SoldToId',
        'ShipToId',
        'ShipToCity',
        'SalesOrganisationText',
        'DistributionChannelText',
        'DivisionText',
        'Incoterms2'
    ],
    OrderLines: [
        'ProductName',
        'ProductNumber',
        'CustomerProductNumber',
        'RequestedDate',
        'RequestedQty',
        'NetValue',
        'RequestedUnit',
        'ScheduleLineConfirmedDate',
        'ScheduleLineNumber',
        'Currency',
        'LineNumber',
        'ConfirmedQty',
        'ConfirmedUnit'
    ],
    Shipping: [
        'GoodsMovementDate',
        'EstimatedShippingDate',
        'ShipFlightNumber',
        'BlNumber',
        'CarrierName',
        'Container',
        'ContainerType',
        'EstimatedArrivalDate',
        'ActualArrivalDate',
        'FreightOrderMainCarriage',
        'FreightOrderPreCarriage',
        'BookingNumber'
    ],
    Invoice: ['InvoiceNumber', 'StateInvoice']
};

//Columns that should not be shown in the xlsx export
export const XLSX_EXCLUDED_TABLE_COLUMNS = [
    'OrderLines',
    'ExtensionProperties',
    'ScheduleLines',
    'FindingPlace',
    'SalesOrganisation',
    'DistributionChannel',
    'Division',
    // 'LineNumber',
    'RecordCreatedDate',
    'highlight', //search terms
    'highlightOrderLines' //search terms
];

export const XLSX_SCHEDULE_LINE_COLUMN_CONFIRMED_QTY = 'ConfirmedQty';
export const XLSX_SCHEDULE_LINE_COLUMN_CONFIRMED_UNIT = 'ConfirmedUnit';
export const XLSX_SCHEDULE_LINE_COLUMN_CONFIRMED_DATE = 'ConfirmedDate';
export const XLSX_SCHEDULE_LINE_COLUMN_CREATED_ON = 'Created On';
export const XLSX_SCHEDULE_LINE_COLUMN_REQ_DATE = 'Req. Date';
export const XLSX_SCHEDULE_LINE_COLUMN_NUMBER = 'ScheduleLineNumber';

export const XLSX_WORKSHEET_NAME = 'Orders';

// file extension
export const XLSX_FILETYPE = 'xlsx';

// Filename for exported file
const currentDate = new Date();
export const XLSX_FILE_NAME_ORDER_HISTORY = `LOOP_order-history_${currentDate.toLocaleDateString()}.${XLSX_FILETYPE}`;
